
































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import ConfirmDialog from "@/components/dialogs/confirmDialog.vue";
import AddMemberDialog from "./add-member-dialog.vue";
@Component({
  components: {
    ConfirmDialog,
    AddMemberDialog
  }
})
export default class MemberManage extends Vue {
  private project: any = {
    project_id: ""
  };
  private roles: any = [
    {
      label: "数据管理员",
      value: "管理员"
    },
    {
      label: "录入员",
      value: "录入员"
    }
  ];
  private cRole: any = {
    label: "数据管理员",
    value: "管理员"
  };
  private members: any = [];
  private cMember: any = {};
  // 弹窗
  private ifShowAddMemberDialog: boolean = false;
  private ifShowConfirmDialog: boolean = false;
  /**
   * @description 获得项目信息
   */
  private fetchProject() {
    return new Promise((resolve, reject) => {
      const params: any = {
        params: {
          project_id: this.project.project_id
        }
      };
      axios
        .get("api/project", params)
        .then(({ data }) => {
          resHandle(this, data).then(() => {
            this.project = data.data;
            resolve();
          });
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 改变角色
   */
  private changeRole(role) {
    this.cRole = role;
    this.fetchMembers();
  }
  /**
   * @description 打开添加成员弹窗
   */
  private addMember() {
    this.cMember = {};
    this.ifShowAddMemberDialog = true;
  }
  /**
   * @description 获得成员列表
   */
  private fetchMembers() {
    const params: any = {
      params: {
        project_id: this.project.project_id,
        角色: this.cRole.value
      }
    };
    axios.get("api/project/users", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.members = data.data;
      });
    });
  }
  /**
   * @description 处理添加成员完成
   */
  private handleAddedFinish(ev) {
    this.ifShowAddMemberDialog = false;
    this.fetchMembers();
  }
  /**
   * @description 打开编辑成员弹窗
   */
  private composeThis(member) {
    this.cMember = member;
    this.ifShowAddMemberDialog = true;
  }
  /**
   * @description 打开删除弹窗
   */
  private openDeleteConfirmDialog(member) {
    this.cMember = member;
    this.ifShowConfirmDialog = true;
  }
  /**
   * @description 删除成员
   */
  private deleteMember() {
    const params: any = {
      data: {
        project_id: this.project.project_id,
        user_id: this.cMember.user_id
      }
    };
    axios.delete("api/project/user", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.ifShowConfirmDialog = false;
        this.$message.success("删除成功");
        this.fetchMembers();
      });
    });
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    this.project.project_id = this.$route.params.project_id;
    this.fetchProject().then(() => {
      this.fetchMembers();
    });
  }
}
